import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "arq_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch {
      stored = null;
    }
    if (!stored) {
      setVisible(true);
      const t = setTimeout(() => setEntered(true), 400);
      return () => clearTimeout(t);
    }
  }, []);

  const persist = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore storage errors */
    }
    setEntered(false);
    setTimeout(() => setVisible(false), 350);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 md:px-6 md:pb-6 flex justify-center pointer-events-none"
      data-testid="cookie-consent"
    >
      <div
        className={`pointer-events-auto w-full max-w-3xl rounded-2xl border border-white/10 bg-[#08100E]/90 backdrop-blur-xl shadow-2xl transition-all duration-500 ${
          entered ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
        }`}
      >
        <div className="relative p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <button
            onClick={() => persist("dismissed")}
            aria-label="Dismiss"
            className="absolute right-3 top-3 text-white/40 hover:text-white/80 transition-colors"
            data-testid="cookie-consent-close"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="flex items-start gap-3 flex-1">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#27BEAA]/10 border border-[#27BEAA]/50">
              <Cookie className="h-4 w-4 text-[#27BEAA]" />
            </span>
            <div>
              <p className="text-sm font-medium text-white">We value your privacy</p>
              <p className="mt-1 text-[13px] leading-relaxed text-white/60">
                We use cookies to enhance your browsing experience and analyze site traffic. By clicking
                &ldquo;Accept All&rdquo;, you consent to our use of cookies.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            <button
              onClick={() => persist("declined")}
              className="rounded-full border border-white/20 px-5 py-2.5 text-sm font-medium text-white/80 hover:bg-white/5 transition-colors duration-300"
              data-testid="cookie-consent-decline"
            >
              Decline
            </button>
            <button
              onClick={() => persist("accepted")}
              className="rounded-full bg-[#27BEAA]/10 border border-[#27BEAA]/60 px-6 py-2.5 text-sm font-medium text-[#27BEAA] hover:bg-[#27BEAA]/20 backdrop-blur-sm transition-colors duration-300"
              data-testid="cookie-consent-accept"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
